import ms from 'ms'
import fiatAssetsAtomDefinition from './atoms/assets.js'
import fiatConfigAtomDefinition from './atoms/config.js'
import fiatCountriesAtomDefinition from './atoms/countries.js'
import fiatDismissedCtasAtomDefinition from './atoms/dismissed-ctas.js'
import fiatHiddenFailedOrderNotificationsDefinition from './atoms/hidden-failed-order-notifications.js'
import fiatAuthKeyPairAtomDefinition from './atoms/key-pair.js'
import fiatUserAtomDefinition from './atoms/user.js'
import fiatRampDefinition from './module/fiat-ramp.js'
import fiatOrdersDefinition from './module/fiat-orders.js'
import fiatOrdersAtomDefinition from './atoms/orders.js'
import fiatOrdersNeedsUpdateAtomDefinition from './atoms/orders-needs-update.js'
import fiatRampApiDefinition from './api/index.js'
import fiatOrdersMonitorDefinition from './monitors/fiat-orders-monitor.js'
import fiatRampPluginDefinition from './plugin/index.js'
import fiatRampReportDefinition from './report/index.js'
import fiatCompletedOrdersAtomDefinition from './atoms/completed-orders.js'
import fiatRampAnalyticsPluginDefinition from './plugin/analytics.js'

const FIAT_SERVER_URL_SANDBOX = 'https://fiat-d.a.exodus.io/'
const FIAT_SERVER_URL_PRODUCTION = 'https://fiat.a.exodus.io/'

const DEFAULT_CONFIG = {
  fetchInterval: ms('30s'),
  maxAge: ms('4d'),
  retryInterval: ms('5s'),
}

const ENV_CONFIG = {
  sandbox: {
    FIAT_SERVER_URL: FIAT_SERVER_URL_SANDBOX,
  },
  production: {
    FIAT_SERVER_URL: FIAT_SERVER_URL_PRODUCTION,
  },
}

const fiatRamp = (
  { sandbox = false, configOverrides = Object.create(null) } = Object.create(null)
) => {
  const environmentConfig = sandbox ? ENV_CONFIG.sandbox : ENV_CONFIG.production
  const {
    FIAT_SERVER_URL,
    useDeterministicAuthKeyPair,
    provider,
    fetchInterval,
    maxAge,
    retryInterval,
  } = {
    ...DEFAULT_CONFIG,
    ...environmentConfig,
    ...configOverrides,
  }

  return {
    id: 'fiatRamp',
    definitions: [
      {
        definition: fiatAssetsAtomDefinition,
      },
      {
        definition: fiatAuthKeyPairAtomDefinition,
      },
      {
        definition: fiatConfigAtomDefinition,
      },
      {
        definition: fiatCountriesAtomDefinition,
      },
      {
        definition: fiatDismissedCtasAtomDefinition,
      },
      {
        definition: fiatHiddenFailedOrderNotificationsDefinition,
        storage: { namespace: 'fiatRamp' },
      },
      // eslint-disable-next-line @exodus/hydra/missing-storage-namespace
      {
        definition: fiatOrdersAtomDefinition,
      },
      {
        definition: fiatOrdersNeedsUpdateAtomDefinition,
      },
      {
        definition: fiatCompletedOrdersAtomDefinition,
      },
      {
        definition: fiatOrdersDefinition,
      },
      {
        definition: fiatUserAtomDefinition,
      },
      {
        definition: fiatRampDefinition,
        config: {
          provider,
          useDeterministicAuthKeyPair,
          FIAT_SERVER_URL,
        },
      },
      { definition: fiatRampApiDefinition },
      { definition: fiatRampPluginDefinition },
      {
        if: { registered: ['analytics'] },
        definition: fiatRampAnalyticsPluginDefinition,
      },
      { definition: fiatRampReportDefinition },
      {
        definition: fiatOrdersMonitorDefinition,
        config: {
          fetchInterval,
          maxAge,
          retryInterval,
        },
      },
    ],
  }
}

export default fiatRamp
